// extracted by mini-css-extract-plugin
module.exports = {"wrap":"PageLoader_wrap__SUpXD","spinner":"PageLoader_spinner__TBs72","spin":"PageLoader_spin__gst3R"};